export default __webpack_public_path__ + "static/media/6.e9d28a0f.png";